import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ReusePendingObservable } from '@wz-decorators/reusePendingObservable';
import { Observable } from 'rxjs';
import { AuthenticationApiModels } from '../../../../../models/api/authentication-api.models';
import { RegisterFormApiModels } from '../../../../../models/api/register-form-api.models';
import { CommonModels } from '../../../../../models/common.models';
import { ConfigurationModels } from '../../../../../models/configuration.models';
import { ApiServiceBase } from './api-service-base';

@Injectable({
  providedIn: 'root',
})
export class AuthenticationApiService extends ApiServiceBase {
  constructor(
    config: ConfigurationModels.Configuration,
    httpClient: HttpClient,
  ) {
    super(config, httpClient, 'account');
  }

  login(
    login: string,
    password: string,
    accountKind: CommonModels.AccountKind,
  ): Observable<AuthenticationApiModels.TokensResponse> {
    return this.post(
      '/login',
      { login, password, accountKind },
      { withCredentials: false },
    );
  }

  logoff() {
    return this.post('/logout', {});
  }

  @ReusePendingObservable()
  me(): Observable<AuthenticationApiModels.AccountInfoResponse> {
    return this.getJson<AuthenticationApiModels.AccountInfoResponse>('/infos');
  }

  registerBroker(
    registrationForm: RegisterFormApiModels.RegisterRequest,
  ): Observable<AuthenticationApiModels.TokensResponse> {
    return this.post('/registerBroker', registrationForm, {
      withCredentials: false,
    });
  }

  createHandlingBroker(
    creationForm: RegisterFormApiModels.RegisterRequest,
    agencyId: number,
  ): Observable<AuthenticationApiModels.TokensResponse> {
    return this.post(`/${agencyId}/createHandlingBroker`, creationForm);
  }

  lostPassword(email: string): Observable<void> {
    return this.post('/lostPassword', { email }, { withCredentials: false });
  }

  resetPassword(password: string, token: string): Observable<void> {
    return this.post(
      '/resetPassword',
      { password, token },
      { withCredentials: false },
    );
  }

  impersonate(
    account: number,
    parentAccountId: number,
    withCredentials = true,
  ): Observable<AuthenticationApiModels.TokensResponse> {
    return this.post<AuthenticationApiModels.TokensResponse>(
      `/${account}/${parentAccountId}/impersonate`,
      {},
      {
        withCredentials: withCredentials,
      },
    );
  }

  loginTunnel(agencyId: number) {
    return this.post<AuthenticationApiModels.TokensResponse>(
      `/loginTunnel`,
      agencyId,
      // { },
      {
        withCredentials: false,
      },
    );
  }

  @ReusePendingObservable()
  renewToken(
    token: string,
  ): Observable<AuthenticationApiModels.AccessTokenResponse> {
    return this.post<AuthenticationApiModels.AccessTokenResponse>(
      '/renew',
      { token },
      { withCredentials: false },
    );
  }
}
